<script>
import appConfig from "@/app.config";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "أنشطة المسؤول",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      title: "أنشطة المسؤول",
      items: [
        {
          text: "قائمة المسؤولین",
          to: { name: "admins" },
        },
        {
          text: "أنشطة المسؤول",
          active: true,
        },
      ],
      page: 0,
      admin: null,
      detailIndex: null,
      isRecordNotFound: false,
      totalItems: 0,
      records: [],
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.page++;
      this.$axios
        .get(`admins/${this.$route.params.id}/activities?page=${this.page}`)
        .then((res) => {
          this.admin = res.data.admin;
          this.totalItems = res.data.total;
          res.data.activities.forEach((item) => {
            const itemFinal = item;
            let color = "";
            if (item.description.endsWith("سجل")) {
              color = "success";
            } else if (item.description.endsWith("حرّر")) {
              color = "warning";
            } else if (item.description.endsWith("ازالت")) {
              color = "danger";
            }
            itemFinal.color = color;
            itemFinal.showDetails = false;
            this.records.push(itemFinal);
          });
        });
    },
    setDetailIndex(i) {
      if (this.detailIndex === i) {
        this.detailIndex = -1;
      } else {
        this.detailIndex = i;
      }
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <error404
      v-if="isRecordNotFound"
      btn-text="العودة الی قائمة المسئوولین"
      route="admins"
      :is-record-error="true"
    ></error404>
    <h4 v-if="records.length === 0">لم يتم تسجيل أي نشاط</h4>
    <div
      v-else-if="admin !== null"
      class="d-flex flex-column justify-content-center"
    >
      <div class="col-xl-10 d-flex flex-column">
        <div class="timeline" dir="ltr">
          <div
            class="timeline-item"
            v-for="(item, index) in records"
            :key="index"
            :class="{ 'timeline-left': index % 2 }"
          >
            <div class="timeline-block" style="direction: rtl">
              <div class="timeline-box card">
                <div
                  class="card-body d-flex flex-column justify-content-start align-items-start"
                >
                  <span class="timeline-icon"></span>
                  <div
                    class="timeline-date ml-auto"
                    :class="index % 2 ? 'mr-md-auto' : 'ml-md-auto'"
                  >
                    <i class="mdi mdi-circle-medium circle-dot"></i>
                    {{ item.time }}
                  </div>
                  <h5 class="mt-3 foont-size-15 text-left">
                    {{ item.description }}
                  </h5>
                  <button
                    @click="item.showDetails = !item.showDetails"
                    class="btn text-primary mr-auto"
                  >
                    {{ item.showDetails === true ? "اقل" : "أكثر" }}
                  </button>
                  <div
                    v-if="item.showDetails === true"
                    class="d-flex gap-16 flex-column w-100 mt-4 p-4"
                  >
                    <div
                      class="d-flex flex-column justify-content-start align-items-start"
                      v-if="item.changes.old"
                    >
                      <h6>التفاصيل السابقة</h6>
                      <span
                        class="mt-2"
                        :class="{
                          'bg-light': value !== item.changes.attributes[key],
                        }"
                        v-for="(value, key) in item.changes.old"
                        :key="`${index}-${key}`"
                      >
                        <strong class="mr-2">{{ $t(key) }}</strong>
                        {{ value }}
                      </span>
                    </div>
                    <hr class="w-100 md:hidden" />
                    <div
                      class="d-flex flex-column justify-content-start align-items-start"
                      v-if="item.changes.attributes"
                    >
                      <h6>التفاصیل الجديدة</h6>
                      <span
                        class="mt-3"
                        :class="{
                          'bg-light':
                            !item.changes.old ||
                            value !== item.changes.old[key],
                        }"
                        v-for="(value, key) in item.changes.attributes"
                        :key="`${index}-${key}`"
                      >
                        <strong class="ml-2">{{ $t(key) }}:</strong>
                        {{ value }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-button
        v-if="items.length < totalItems"
        variant="primary"
        class="mx-auto my-4"
        @click="fetchData"
        >بیشتر
      </b-button>
    </div>
  </Layout>
</template>
